import React, { Component } from 'react';


class About extends Component {
  render() {
    return(
      <div className="contact-body">
    I am a graduate student pursuing my Masters in Computer Science from University of Florida.
    <br></br>
      I have 4 years of work experience in the field of Software Development with expertise in back-end and front-end application development. I was a summer'2020 Senior Senior Engineer Intern at Visa Inc. Prior to my masters, I was working as a Senior Software Engineer at J.C. Penney.</div>
    )
  }
}

export default About;
